import React from 'react';
import * as Mapbox from "react-map-gl/mapbox";
import {FilterSpecification, LayerSpecification, SymbolLayerSpecification} from "mapbox-gl";
import {MapLayer} from "../../../types/MapLayers";

// Types ----

type ExhibitLayerProps = {
  source?: string
  enabledLayers: MapLayer[]
  floorId?: number | null
}

// Component ----

function ExhibitLayer({source = '', enabledLayers, floorId}: ExhibitLayerProps) {

  // Filters
  const exhibitFilter: FilterSpecification = ["==", ["get", "type"], "exhibit"];
  const filter: FilterSpecification = floorId ? [
    'all',
    exhibitFilter,
    ['==', ['get', 'type', ['get', 'location']], 'floor'],
    ['==', ['get', 'id', ['get', 'location']], floorId],
  ] : exhibitFilter;

  // Layout Properties
  const layout: LayerSpecification['layout'] = { visibility: enabledLayers.includes(MapLayer.EXHIBIT) ? "visible" : "none" };

  return (
    <Mapbox.Layer
      type="symbol"
      id="ngage-exhibit"
      source={source}
      filter={filter}
      layout={{...exhibitLayout, ...layout}}
      paint={exhibitPaint}
    />
  );
}

// Styles ----

const exhibitLayout: SymbolLayerSpecification['layout'] = {
  "icon-image": "ngage-pin-exhibit",
  "icon-size": 0.6,
  "icon-anchor": "bottom",
  "icon-keep-upright": true,
  "icon-allow-overlap": true,
  "text-field": ["get", "name"],
  "text-anchor": "top",
}

const exhibitPaint: SymbolLayerSpecification['paint'] = {
  "text-halo-width": 2,
  "text-halo-color": "#FFFFFF",
}

export default ExhibitLayer;